import { InitialFlowRateQiBase } from './base/initial-flow-rate-qi-base';

export class InitialFlowRateQi extends InitialFlowRateQiBase { }